
import React from "react";
import LegalLayout from "@/components/layout/LegalLayout";
import { Scale } from "lucide-react";

const TermsOfService = () => {
  return (
    <LegalLayout 
      title="Terms of Service" 
      icon={<Scale className="h-5 w-5 text-primary" />}
      lastUpdated="July 22, 2025"
    >
      <div className="space-y-4 text-sm text-slate-700 mb-6 p-4 bg-slate-50 rounded-lg">
        <p><strong>Effective Date:</strong> July 22, 2025</p>
        <p><strong>Operator:</strong> Timesy B.V. (KVK: 82843554)</p>
        <p><strong>Address:</strong> Raamplein 1, 1016 XK Amsterdam</p>
        <p><strong>Phone:</strong> +31 6 17422916</p>
        <p><strong>Email:</strong> support@snaprefund.com</p>
      </div>

      <h2>1. Acceptance</h2>
      <p>
        By using SnapRefund, you agree to be legally bound by these Terms.
      </p>
      
      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old and legally capable of entering into contracts under Dutch law.
      </p>
      
      <h2>3. Services Provided</h2>
      <p>
        SnapRefund is a digital platform that helps consumers generate refund request emails, analyze seller responses, and prepare chargeback documentation using AI.
      </p>
      
      <h2>4. User Responsibilities</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the service for illegal or fraudulent activity</li>
        <li>Submit false or misleading information</li>
        <li>Copy, scrape, or reverse-engineer our platform</li>
      </ul>
      <p>You are solely responsible for the accuracy of the data you provide.</p>
      
      <h2>5. Payments</h2>
      <p>
        You may be charged for premium services. All payments are processed securely via trusted third-party processors.
      </p>
      
      <h2>6. No Legal Advice</h2>
      <p>
        SnapRefund does not provide legal representation or advice. It is a technology tool to assist with refund communication.
      </p>
      
      <h2>7. Limitation of Liability</h2>
      <p>
        To the extent permitted by law, Timesy B.V. shall not be liable for indirect or consequential damages, including lost profits or data.
      </p>
      
      <h2>8. Termination</h2>
      <p>
        We may suspend or terminate your access to SnapRefund at our discretion, including for violation of these Terms.
      </p>
      
      <h2>9. Governing Law</h2>
      <p>
        These Terms are governed by Dutch law. Disputes shall be submitted to the competent court in Amsterdam.
      </p>
    </LegalLayout>
  );
};

export default TermsOfService;
